import { createAction } from 'redux-actions';
import { actionPrefix } from './constants';
import { PopoverOptions, PopoverArrayItem } from './types';

export const pushPopoverWithOptions = createAction(
  `${actionPrefix}.PUSH_POPOVER`,
  (id: string, options: PopoverOptions): PopoverArrayItem => {
    return {
      id,
      options,
    };
  }
);

export const pushPopover = (id: string, options: PopoverOptions = {}) =>
  pushPopoverWithOptions(id, options);

export const removePopover = createAction(`${actionPrefix}.REMOVE_POPOVER`, (id: string) => id);
